import { render, staticRenderFns } from "./InspectOrganize.vue?vue&type=template&id=387eeb1e&scoped=true"
import script from "./InspectOrganize.vue?vue&type=script&lang=js"
export * from "./InspectOrganize.vue?vue&type=script&lang=js"
import style0 from "./InspectOrganize.vue?vue&type=style&index=0&id=387eeb1e&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387eeb1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387eeb1e')) {
      api.createRecord('387eeb1e', component.options)
    } else {
      api.reload('387eeb1e', component.options)
    }
    module.hot.accept("./InspectOrganize.vue?vue&type=template&id=387eeb1e&scoped=true", function () {
      api.rerender('387eeb1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/inspectOrganize/InspectOrganize.vue"
export default component.exports